import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useElementSize } from "@vueuse/core";
import { computed, ref } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomScrollVertical',
  props: {
  rightGap: {
    type: Boolean,
    default: true,
  },
},
  setup(__props) {

const props = __props;

const rootEl = ref();

const { height, width } = useElementSize(
  rootEl,
  { height: 0, width: 0 },
  {
    box: "border-box",
  }
);

const innerWidth = computed(() => Math.max(0, width.value - (props.rightGap ? 16 : 0)));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "rootEl",
    ref: rootEl,
    style: {"flex-grow":"1","position":"relative"}
  }, [
    _createElementVNode("div", {
      style: _normalizeStyle({
        height: _unref(height) + 'px',
        width: innerWidth.value + 'px',
        overflowY: 'auto',
        position: 'absolute',
        paddingRight: '1rem',
      }),
      class: "custom-scrollbar"
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 4)
  ], 512))
}
}

})